import React, { useEffect, useRef, useState } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import AttendancePopup from "./AttendancePopup";
import ViewEvaluationpopUp from "./ViewEvaluationpopUp";
import axios from "axios";
import { base_url } from "../../../utils/AxiosConfig";
import { FaEye } from "react-icons/fa";

import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";
import { format } from "date-fns";

import { FaSearch } from "react-icons/fa";

const Evaluation = () => {
  const [data, setData] = useState();
  const [popUpData, setpopUpData] = useState();
  const [Open, setOpen] = useState(false);
  const [reset, setReset] = useState(false);
  const [loader, setLoader] = useState(true);

  const dateInputRef = useRef(null);

  const [loadViewData, setLoadViewData] = useState(false);

  const [date, setDate] = useState("");

  // pagination
  const [currentPage, SetcurrentPage] = useState(1);
  const recordsPerPage = 10;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = data?.slice(firstIndex, lastIndex);
  const npage = Math.ceil(data?.length / recordsPerPage);
  const numbers = Array.from({ length: npage }, (_, i) => i + 1);

  useEffect(() => {
    if (records) {
      setLoader(false);
    }
  }, [records]);

  useEffect(() => {
    console.log("Evaluation");

    const today = new Date();
    setDate(format(today, "yyyy-MM-dd"));

    try {
      const storedUserDataArray =
        JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
      let companyCode = null;

      if (storedUserDataArray) {
        companyCode = storedUserDataArray[0].cmpcode;
      }

      axios
        .get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`,
        )
        .then((res) => {
          setData(res.data);
          setReset(false);
        })
        .catch((err) => {
          console.error("PersonalInfoListerror:", err);
        });
    } catch (error) {
      console.error("PersonalInfoListerror:", error);
    }
  }, []);

  console.log("dateInputRef", dateInputRef);

  const [searchTerm, setSearchTerm] = useState("");

  const filteredRows = records?.filter((d) =>
    d.Name.toLowerCase().includes(searchTerm.toLowerCase()),
  );



     const formatDateWithExpiry = (date) => {
  if (!date) return <span>-</span>;

  const parsed = new Date(date);
  if (isNaN(parsed)) return <span>-</span>;

  const isExpired = parsed < new Date();

  return (
    <span className={isExpired ? "text-red-600 font-medium" : ""}>
      {parsed.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })}
    </span>
  );
};

  return (
    <div className="container">
      <div className="flex items-center justify-between ">
        <div className="mb-4 display flex justify-between items-center  w-[60%]">
          {/* <h6 className="mb-2 head-text">Attendance Evaluation</h6> */}
          {/* <h6 className=" text-2xl font-bold text-gray-600 flex  justify-start items-center"> */}
          <div className="">
            <div className="flex justify-left items-center">
              <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
              <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
                {/* <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#2663EB] to-blue-700 text-white shadow-lg">
      <MdPersonAddAlt className="w-7 h-7" />
      </span> */}
                <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
                  ATTENDANCE EVALUATION
                </span>
              </h6>
            </div>
          </div>
          {/* <div className="flex items-center border-b border-gray-400  pb-1 px-3">
            <FaSearch className="text-gray-400 text-sm mr-2" />
            <input
              type="text"
              placeholder="Search Employee..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="bg-transparent outline-none px-2 py-1 text-sm font-normal rounded "
            />
          </div> */}

          <div className="w-full max-w-sm">
            <div className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-xl shadow-sm transition-all duration-200 focus-within:border-[#2663EB] focus-within:ring-2 focus-within:ring-[#2663EB]/20 hover:shadow-md">
              <FaSearch className="text-gray-400 text-sm transition-colors duration-200 group-focus-within:text-[#2663EB]" />

              <input
                type="text"
                placeholder="Search Employee..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full bg-transparent outline-none text-sm text-gray-700 placeholder-gray-400"
              />

              {searchTerm && (
                <button
                  onClick={() => setSearchTerm("")}
                  className="text-gray-400 hover:text-red-500 text-sm transition-colors"
                >
                  ✕
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between mb-2">
          <div className="flex justify-center gap-4 items-center">
            <div className="relative ">
                  <label >Date</label>

              <input
                type="date"
                ref={dateInputRef}
                value={date}
                onChange={(e) => setDate(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
                className="w-44 px-3 py-2 text-sm border border-gray-300 rounded-lg  focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] outline-none text-gray-700"
              />
            </div>
          </div>
          <div className="ml-4">
            {Open === true ? (
              <>
                <LuPanelRightOpen onClick={() => setOpen(false)} />
              </>
            ) : null}
            {Open === false ? (
              <>
                <LuPanelLeftOpen onClick={() => setOpen(true)} />
              </>
            ) : null}
          </div>
        </div>
      </div>

      {/* <div className={Open ? "table scroll" : "table scroll"}> */}
      <div className="overflow-auto scrollbar-none">
        {records ? (
          <>
            {/* <table class="table"> */}
            <table className="shadow-sm min-w-full bg-white rounded-sm border border-[gray-300] text-xs ">
              <thead>
                <tr className="bg-[#2663EB] text-white">
                  <th className="px-2 py-1 border-none  font-normal">Sl No</th>
                  <th className="px-2 py-1 border-none font-normal">Emp Id</th>
                  <th className="px-2 py-1 border-none font-normal">
                    Alternate Id
                  </th>
                  <th className="px-2 py-1 border-none font-normal">Status</th>
                  <th className="px-2 py-1 border-none font-normal">Name</th>
                  <th className="px-2 py-1 border-none font-normal">
                    Job Title
                  </th>
                  <th className="px-2 py-1 border-none font-normal">
                    Division
                  </th>
                  <th className="px-2 py-1 border-none font-normal">Grade</th>
                  <th className="px-2 py-1 border-none font-normal">Gender </th>
                  <th className="px-2 py-1 border-none font-normal">
                    Nationality
                  </th>
                  {Open ? (
                    <>
                      <th className="px-2 py-1 border-none font-normal">
                        Bank Account
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Bank Name
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Agent Id
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Current Address
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Home Address
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Home Airport
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Work Mobile
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Work Phone
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Personal Phone
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Personal Email
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Passport Number
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Passport Issue Date
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Passport Expiry Date
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Passport Place of Issue
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Passport Country of Issue
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Emirates id
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Expiry Date
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Visa No
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Visa Expiry Date
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Insurance Number
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Insurance Expiry Date
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Driving license No
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Driving license Expiry Date
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Basic Pay
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Allowances_OT
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Allownaces_NOT
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        NormalHRS
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        HourlyWage
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        OTRate
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        SplOtRate
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Active
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Memos
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Notes
                      </th>
                      <th className="px-2 py-1 border-none font-normal">
                        Salary Ac
                      </th>
                      <th className="px-2 py-1 border font-normal">
                        Advance Ac
                      </th>
                    </>
                  ) : null}
                  <th className="px-2 py-1 border-none font-normal">Actions</th>
                </tr>
              </thead>
              <tbody>
                {records
                  ? filteredRows?.map((d, i) => (
                      <>
                        {/* <tr key={i} className="dataTr"> */}
                        <tr key={i} className="">
                          <td className="px-2 py-1 border">{i + 1}</td>
                          <td className="px-2 py-1 border">{d?.EmpId}</td>
                          <td className="px-2 py-1 border">{d?.AlternateID}</td>
                          <td className="px-2 py-1 border">{d?.Status}</td>
                          <td className="px-2 py-1 border">{d?.Name}</td>
                          <td className="px-2 py-1 border">{d?.JobTitle}</td>
                          <td className="px-2 py-1 border">{d?.Division}</td>
                          <td className="px-2 py-1 border">{d?.Grade}</td>
                          <td className="px-2 py-1 border">{d?.Single}</td>
                          <td className="px-2 py-1 border">{d?.Nationality}</td>
                          {Open ? (
                            <>
                              <td className="px-2 py-1 border">
                                {d?.BankAccountNo}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.BankName}
                              </td>
                              <td className="px-2 py-1 border">{d?.AgentID}</td>
                              <td className="px-2 py-1 border">
                                {d?.CurrentAddress}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.HomeAddress}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.HomeAirport}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.WorkMobile}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.WorkPhone}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.PersonalPhone}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.PersonalEmail}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.PassportNo}
                              </td>
                              <td className="px-2 py-1 border">
                                {formatDateWithExpiry(d?.PassportIssueDate)}
                              </td>
                              <td className="px-2 py-1 border">
                                {formatDateWithExpiry(d?.PassportExpiryDate)}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.PassportPlaceofIssue}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.PassportCountryofIssue}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.EmiratesId}
                              </td>
                              <td className="px-2 py-1 border">
                                {formatDateWithExpiry(d?.EmiratesIdExpiryDate)}
                              </td>
                              <td className="px-2 py-1 border">{d?.VisaNo}</td>
                              <td className="px-2 py-1 border">
                                {formatDateWithExpiry(d?.VisaExpiryDate)}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.InsuranceNo}
                              </td>
                              <td className="px-2 py-1 border">
                                {formatDateWithExpiry(d?.InsuranceExpiryDate)}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.DrivingLicenceNo}
                              </td>
                              <td className="px-2 py-1 border">
                                {formatDateWithExpiry(d?.DrivingLicenceExpiryDate)}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.BasicPay}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.Allowances_OT}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.Allowances_NOT}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.NormalHrs}
                              </td>
                              <td className="px-2 py-1 border">
                                {d?.HourlyWage}
                              </td>
                              <td className="px-2 py-1 border">{d?.OTrate}</td>
                              <td className="px-2 py-1 border">
                                {d?.SplOtRate}
                              </td>
                              <td className="px-2 py-1 border">{d?.Active}</td>
                              <td className="px-2 py-1 border">{d?.Memos}</td>
                              <td className="px-2 py-1 border">{d?.Notes}</td>
                              <td className="px-2 py-1 border">{d?.SalaryA}</td>
                              <td className="px-2 py-1 border">
                                {d?.AdvanceAc}
                              </td>
                            </>
                          ) : null}
                          <td className="px-2 py-1 border text-center">
                            {/* <button
                              className="dash-btn"
                              data-bs-toggle="modal"
                              data-bs-target="#staticBackdrop"
                              onClick={()=>setpopUpData(d)}
                            >
                              <IoIosAddCircleOutline />
                              &nbsp;Add
                            </button> */}
                            &nbsp;
                            <button
                              // className="dash-btn mt-2"
                              className="bg-green-600 text-white px-2 py-1 rounded-md font-semibold"
                              data-bs-toggle="modal"
                              data-bs-target="#staticBackdropnew"
                              onClick={() => {
                                setpopUpData(d);
                                setLoadViewData(true);
                              }}
                            >
                              {/* <FaEye /> */}
                              {/* &nbsp;View */}
                              Evaluate
                            </button>
                          </td>
                        </tr>
                      </>
                    ))
                  : null}
              </tbody>
            </table>
          </>
        ) : null}
      </div>
      {records ? (
        <>
          <div className="pagination-div">
            <div className="text-end">
              <nav aria-label="Page navigation example">
                <ul class="pagination mt-4">
                  <li class="page-item">
                    {currentPage !== 1 ? (
                      <button
                        class="page-link rounded"
                        href="#"
                        onClick={prePage}
                      >
                        Previous
                      </button>
                    ) : (
                      ""
                    )}
                  </li>
                  {numbers.map((n, i) => (
                    <li
                      className={`page-item ${
                        currentPage === n ? "active" : ""
                      }`}
                      key={i}
                    >
                      <button
                        className="page-link rounded"
                        onClick={() => changeCPage(n)}
                        href="#"
                      >
                        {n}
                      </button>
                    </li>
                  ))}

                  <li class="page-item">
                    {currentPage !== numbers[numbers.length - 1] ? (
                      <button
                        class="page-link rounded "
                        href="#"
                        onClick={nextPage}
                      >
                        Next
                      </button>
                    ) : null}
                  </li>
                </ul>
              </nav>
            </div>
            {/* <SnackbarNotification
                    open={snackbar.open}
                    severity={snackbar.severity}
                    message={snackbar.message}
                    onClose={handleClose}
            
                  /> */}
          </div>
        </>
      ) : null}

      {date && (
        <AttendancePopup popUpData={popUpData} date={date} setDate={setDate} />
      )}

      {date && <ViewEvaluationpopUp popUpData={popUpData} date={date} />}

      <div className="table-nodata-img mtd">
        {loader ? (
          <>
            {" "}
            {/* <div className="table-nodata-img">
              <div className="center">
                <p className="text-center pt-5">
                  Please Wait Loading Data... &nbsp;
                  <FallingLines />
                </p>
              </div>
            </div> */}
          </>
        ) : null}
      </div>
    </div>
  );

  function prePage() {
    if (currentPage !== firstIndex) {
      SetcurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    SetcurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== lastIndex) {
      SetcurrentPage(currentPage + 1);
    }
  }
};

export default Evaluation;
